<template>
  <div class="banner-container">
    <CkContent></CkContent>
  </div>
</template>

<script>
import CkContent from './CkContent'

export default {
  name: 'BannerDetail',
  components: {
    CkContent
  },
  data() {
    return {
      loadingComponent: null,
      isLoading: false
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  margin-top: #{$headerHeight};
  height: calc(100vh - #{$headerHeight} - #{$footerHeight});
}
@media print {
  .banner-container {
    display: none;
  }
}
</style>
